import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    error: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Error message shown when updating folder color fails */
            error: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useFolderColor.error?c=6avm8dsmb7k5", defaultMessage: "There was an issue updating the folder color" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
